import { openHref } from '@zocdoc-frontend-common/utils-react';
import { isProductionBuild } from '@zocdoc-mezzanine/internal-shared';

export const BEFORE_TIMEOUT = 200;

export const timeout = (promise, ms) => Promise.race([promise, wait(ms)]);

export const wait = (ms) =>
    new Promise((resolve, reject) => {
        setTimeout(
            () =>
                reject(
                    new Error(
                        `beforeClick did not finish executing before timeout of ${ms} ms`
                    )
                ),
            ms
        );
    });

export const throwErrOrOpenHref = (event, href, err) => {
    if (isProductionBuild()) {
        openHref(event, href);
    } else {
        throw err;
    }
};
